import { ElementType, useMemo } from 'react'
import { Globe, Video } from 'lucide-react'

const parseUrl = (value: string) => {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

const normalizeHost = (hostname: string) =>
  hostname.toLowerCase().replace(/^www\./, '')

const isZoomLink = (host: string) =>
  host === 'zoom.us' || host.endsWith('.zoom.us')

const isGoogleMeetLink = (host: string, pathname: string) =>
  host === 'meet.google.com' ||
  (host === 'g.co' && pathname.startsWith('/meet'))

const getEventUrlMeta = (url: URL): [ElementType, string] => {
  const host = normalizeHost(url.hostname)
  const pathname = url.pathname.toLowerCase()

  switch (true) {
    case isZoomLink(host):
      return [Video, 'Zoom']
    case isGoogleMeetLink(host, pathname):
      return [Video, 'Google Meet']
    default:
      return [Globe, host]
  }
}

export const useEventUrl = (url?: string | null) =>
  useMemo(() => {
    if (!url) return

    const parsedUrl = parseUrl(url)
    if (!parsedUrl) return

    const [IconComponent, label] = getEventUrlMeta(parsedUrl)
    return {
      url,
      Icon: <IconComponent />,
      label,
    }
  }, [url])
